import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {AppSyncHelper} from './helpers/app-sync.helper';

@NgModule({
  imports: [CommonModule], providers: [AppSyncHelper]
})
export class CoachBotDataAccessCoreModule {}
